var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('parallax-section'),_vm._v(" "),_c('about-section'),_vm._v(" "),_c('advantages-section'),_vm._v(" "),_c('partners-section'),_vm._v(" "),_c('contact-section'),_vm._v(" "),_c('footer-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }